import { contains, inflate, overlaps } from "./rect";
const PANEL_GAP = 24;
/** The wider full-height strip of the canvas left or right of the panel. */ function widerStripBeside(panel, canvas) {
    const { x, y, width, height } = canvas;
    const left = {
        x,
        y,
        width: panel.x - PANEL_GAP - x,
        height
    };
    const rightX = panel.x + panel.width + PANEL_GAP;
    const right = {
        x: rightX,
        y,
        width: x + width - rightX,
        height
    };
    return left.width >= right.width ? left : right;
}
/**
 * Screen shift that brings `node` into view beside the detail `panel`, all
 * rects in client coordinates: none when it is already on the canvas and clear
 * of the panel, else centred in the wider free strip beside it, even when that
 * strip is narrower than the node.
 */ export function revealShift(node, panel, canvas) {
    const clearOfPanel = !overlaps(node, inflate(panel, PANEL_GAP));
    if (contains(canvas, node) && clearOfPanel) return {
        dx: 0,
        dy: 0
    };
    const target = widerStripBeside(panel, canvas);
    return {
        dx: target.x + target.width / 2 - (node.x + node.width / 2),
        dy: target.y + target.height / 2 - (node.y + node.height / 2)
    };
}

//# sourceMappingURL=revealShift.js.map